import React from 'react';
import styles from './InfoTab.module.scss';
import { isEmpty } from 'lodash';
import { PlayerInfo } from '../PlayerInfo/PlayerInfo';
import { DetailsSkeleton } from '../Skeleton/DetailsSkeleton';
import { useStore } from '../../../../../common';
import { playerPersonalFields, playerBasicFields, playerActivityFields, playerBonusFields } from './InfoTab.const';
import { History } from '../History/History';

const InfoTab = (): JSX.Element => {
	const [state] = useStore();
	const { player, playerLoading } = state;

	return (
		<section className={styles.PageContent}>
			{!isEmpty(player?.playerData) && (
				<>
					<div className={styles.ProfileSection}>
						<PlayerInfo player={player.playerData} fields={playerBasicFields} />
						<PlayerInfo player={player.playerData} fields={playerPersonalFields} />
					</div>
					<div className={styles.ProfileSection}>
						<PlayerInfo player={player.playerData} fields={playerActivityFields} />
						<section className={styles.Section}>
							<PlayerInfo player={player.playerRealBonus} fields={playerBonusFields} />
							{!isEmpty(player.playerLastActivity) && <History data={player.playerLastActivity} />}
						</section>
					</div>
				</>
			)}
			{playerLoading && <DetailsSkeleton />}
		</section>
	);
};
export { InfoTab };
